import React from "react"
import { type ChakraProps, Heading, useColorMode } from "@chakra-ui/react"
import { Colors } from "../../theme/colors"

interface Heading2CapsPropsInterface {
  text: string
  props?: ChakraProps
}
export const Heading2Caps = ({ text, props }: Heading2CapsPropsInterface): JSX.Element => {
  const { colorMode } = useColorMode()
  let borderBottomWidth = "3px"
  if (typeof props?.borderBottomWidth === "string") {
    borderBottomWidth = props.borderBottomWidth
  }

  return (
    <Heading
      color={colorMode === "light" ? "blackText" : "white"}
      variant={"Heading3CAPS"}
      borderBottomWidth={borderBottomWidth}
      borderBottomColor={Colors.Primary.accent}
      textAlign={"center"}
      px="6"
      py="10px"
      m="0px"
      mx="auto"
      display={"inline-block"}
      fontSize={["24px", "24px", "22.5px"]}
      lineHeight={["25px", "28px", "26.25px"]}
      {...props}
    >
      {text}
    </Heading>
  )
}
